import { HomeOrganizationAnnouncementPage } from './HomeOrganizationAnnouncementPage';
export default HomeOrganizationAnnouncementPage;
